import type { Tables } from "@/integrations/supabase/types";

type Profile = Tables<"profiles">;

/**
 * Single source of truth: is this profile still in onboarding?
 * Used by both AppShell (route guard) and Profile page (UI).
 */
export function isProfileOnboarding(profile: Profile | null): boolean {
  if (!profile) return true; // no profile loaded yet — assume onboarding to gate routes
  // Only gate on truly essential fields — everything else is optional enhancement
  return !profile.display_name || !profile.avatar_url;
}
